// GENERATED by tools/gen-catalogue.mjs from packs/main-character/catalogue/products.jsonl.
// Do not edit by hand. 30 real Main Character products, real KL codes, real rupee prices.
import type { Product } from '../lib/types.ts';

export const MOCK_PRODUCTS: Product[] = [
  {
    "id": "mc-abstract-side-table-set-of-2",
    "code": "KL 1874",
    "title": "Abstract Cocktail Table Set Of 2",
    "category": "side_table_consoles",
    "subcategory": "Cocktail Table",
    "materials": [
      "Top-Bottom Engineered Wood",
      "Bone Inlay",
      "With Brass Painted Iron Rod"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Brass"
    ],
    "priceMin": 54000,
    "priceMax": 54000,
    "currency": "INR",
    "dims": "25.5L x 25.5W x 57.5H",
    "description": "Crafted with meticulous attention to detail, the Abstract Cocktail Table Set combines artistry and functionality. Featuring a sleek bone-inlay design on a sturdy engineered wood base and accentuated by a brass-painted iron rod, these tables blend contemporary sophistication with timeless charm. Perfect as accent pieces",
    "active": true,
    "media": [
      {
        "id": "mc-abstract-side-table-set-of-2-m1",
        "path": "abstract-side-table-set-of-2/01_45189260738781.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-abstract-side-table-set-of-2-m2",
        "path": "abstract-side-table-set-of-2/02_45170407604445.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-abstract-side-table-set-of-2-m3",
        "path": "abstract-side-table-set-of-2/03_45170407637213.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-abstract-side-table-set-of-2-m4",
        "path": "abstract-side-table-set-of-2/04_45170407669981.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-abstract-side-table-set-of-2-m5",
        "path": "abstract-side-table-set-of-2/05_45170407702749.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-abstract-side-table-set-of-2-m6",
        "path": "abstract-side-table-set-of-2/06_45170407735517.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-agate-top-side-table",
    "code": "KL 2105",
    "title": "Agate Top Cocktail Table",
    "category": "side_table_consoles",
    "subcategory": "Cocktail Table",
    "materials": [
      "Agate Stone",
      "Marble Base"
    ],
    "colours": [
      "Default Title",
      "Gold",
      "Brass"
    ],
    "priceMin": 32000,
    "priceMax": 32000,
    "currency": "INR",
    "dims": "30L x 20W x 60H",
    "description": "This resplendent agate drink table, a testament to nature's magnificence and artisanal mastery, radiates with enchanting purple tones and intricate, otherworldly banding. The lustrous agate top, evocative of celestial artistry, is gracefully encircled by a gleaming gold rim that elevates its opulent allure. Resting upo",
    "active": true,
    "media": [
      {
        "id": "mc-agate-top-side-table-m1",
        "path": "agate-top-side-table/01_45189332795613.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-agate-top-side-table-m2",
        "path": "agate-top-side-table/02_45170585960669.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-agate-top-side-table-m3",
        "path": "agate-top-side-table/03_45170585993437.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-agate-top-side-table-m4",
        "path": "agate-top-side-table/04_45170586026205.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-agra-side-table-1",
    "code": "KL 1432 A",
    "title": "Agra Cocktail Table",
    "category": "side_table_consoles",
    "subcategory": "Cocktail Table",
    "materials": [
      "Engineered Wood Structure",
      "Metal Cladding",
      "Marble Base"
    ],
    "colours": [
      "Champagne Silver",
      "White",
      "Green",
      "Red",
      "Grey"
    ],
    "priceMin": 47000,
    "priceMax": 47000,
    "currency": "INR",
    "dims": "31L x 31W x 51H",
    "description": "Unveil a bold blend of industrial allure and timeless sophistication with this striking cocktail table. Featuring a textured gunmetal-finished top and centerpiece, paired with a pristine white marble base, this design exudes a raw yet refined charm. Its sculptural form pairs effortlessly with muted palettes - imagine i",
    "active": true,
    "media": [
      {
        "id": "mc-agra-side-table-1-m1",
        "path": "agra-side-table-1/01_45189352751325.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-agra-side-table-1-m2",
        "path": "agra-side-table-1/02_45159373734109.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-amber-marble-side-table-1",
    "code": "KL 1821 C",
    "title": "Amber Marble Cocktail Table",
    "category": "side_table_consoles",
    "subcategory": "Cocktail Table",
    "materials": [
      "Marble Top & Base With Brass Painted Iron Rod"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Brass",
      "Natural"
    ],
    "priceMin": 28000,
    "priceMax": 28000,
    "currency": "INR",
    "dims": "25.5L x 25.5W x 57.5H",
    "description": "Introduce a touch of opulence with the Amber Marble Cocktail Table. A harmonious interplay of natural luxury and contemporary finesse. Anchored by a richly veined marble base, its smooth marble top rests gracefully on a slender iron rod bathed in a luminous brass finish. This sculptural masterpiece isn't just a table -",
    "active": true,
    "media": [
      {
        "id": "mc-amber-marble-side-table-1-m1",
        "path": "amber-marble-side-table-1/01_45873076830429.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-amber-marble-side-table-1-m2",
        "path": "amber-marble-side-table-1/02_45170393579741.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-arch-console-1",
    "code": "KL 2194",
    "title": "Arch Console",
    "category": "side_table_consoles",
    "subcategory": "Console Table",
    "materials": [
      "Wood & Engineered Wood Structure",
      "Brass Sheet Cladding"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 65000,
    "priceMax": 65000,
    "currency": "INR",
    "dims": "120L x 30W x 75H",
    "description": "Inspired by architectural grandeur, the Arch Console blends hammered metal cladding with bold geometric design. The sculptural arches and metallic detailing create a striking interplay of light and shadow, making it a statement piece for any space. Perfect for those who appreciate modern sophistication with a timeless ",
    "active": true,
    "media": [
      {
        "id": "mc-arch-console-1-m1",
        "path": "arch-console-1/01_45189583306973.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-arch-console-1-m2",
        "path": "arch-console-1/02_45167050522845.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-arch-console-1-m3",
        "path": "arch-console-1/03_45167073067229.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-arch-console-1-m4",
        "path": "arch-console-1/04_45167050588381.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-arch-console-1-m5",
        "path": "arch-console-1/05_45167049146589.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-athena-credenza-w-m",
    "code": "KL 1833",
    "title": "Athena Credenza W/M",
    "category": "chest_cabinet",
    "subcategory": "Sideboard",
    "materials": [
      "Engineered Wood Structure",
      "Metal Cladding"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 211000,
    "priceMax": 211000,
    "currency": "INR",
    "dims": "178L x 50W x 75H",
    "description": "The Athena Credenza is a masterful blend of contemporary allure and rustic sophistication. Its façade is adorned with meticulously crafted geometric textures, offering a striking interplay of depth and dimension. The muted metallic finish radiates understated opulence, making it a perfect fusion of modern elegance and ",
    "active": true,
    "media": [
      {
        "id": "mc-athena-credenza-w-m-m1",
        "path": "athena-credenza-w-m/01_45189416321245.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-athena-credenza-w-m-m2",
        "path": "athena-credenza-w-m/02_45167424798941.jpg",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m3",
        "path": "athena-credenza-w-m/03_45167424831709.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m4",
        "path": "athena-credenza-w-m/04_45167424864477.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m5",
        "path": "athena-credenza-w-m/05_45167424897245.jpg",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m6",
        "path": "athena-credenza-w-m/06_45167424930013.jpg",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m7",
        "path": "athena-credenza-w-m/07_45167424962781.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m8",
        "path": "athena-credenza-w-m/08_45167424995549.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m9",
        "path": "athena-credenza-w-m/09_45167425028317.webp",
        "role": "detail",
        "sort": 9,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-athena-credenza-w-m-m10",
        "path": "athena-credenza-w-m/10_45167425061085.jpg",
        "role": "detail",
        "sort": 10,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-aziza-2-door-cabinet",
    "code": "KL 1723",
    "title": "Aziza 2 Door Cabinet",
    "category": "chest_cabinet",
    "subcategory": "Cabinet",
    "materials": [
      "Wood Structure",
      "Bone Inlay",
      "Brass Plated Stand"
    ],
    "colours": [
      "Natural Wood",
      "White",
      "Red",
      "Brass"
    ],
    "priceMin": 93000,
    "priceMax": 93000,
    "currency": "INR",
    "dims": "100L x 45W x 88H",
    "description": "The Aziza 2-Door Cabinet brings a quiet geometry to life through hand-applied bone inlay. Set against a warm wooden frame, the doors feature a rhythmic, linear pattern that draws the eye in subtle, shifting motion. The brass-finished handles and tapered legs add a refined accent, grounding the piece in modern sophistic",
    "active": true,
    "media": [
      {
        "id": "mc-aziza-2-door-cabinet-m1",
        "path": "aziza-2-door-cabinet/01_45191235993821.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-aziza-2-door-cabinet-m2",
        "path": "aziza-2-door-cabinet/02_45191222198493.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-aziza-2-door-cabinet-m3",
        "path": "aziza-2-door-cabinet/03_45191222165725.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-aziza-2-door-cabinet-m4",
        "path": "aziza-2-door-cabinet/04_45191222034653.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-aziza-2-door-cabinet-m5",
        "path": "aziza-2-door-cabinet/05_45191222132957.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-aziza-2-door-cabinet-m6",
        "path": "aziza-2-door-cabinet/06_45191222001885.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-aziza-2-door-cabinet-m7",
        "path": "aziza-2-door-cabinet/07_45191222067421.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-aziza-2-door-cabinet-m8",
        "path": "aziza-2-door-cabinet/08_45191222100189.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-casablanca-mirror-frame-mop",
    "code": "KL 250",
    "title": "Casablanca Mirror Frame Mop",
    "category": "mirrors",
    "subcategory": "Mirror",
    "materials": [
      "Wood",
      "Mother of Pearl Inlay"
    ],
    "colours": [
      "Default Title"
    ],
    "priceMin": 49000,
    "priceMax": 49000,
    "currency": "INR",
    "dims": "120L x 70H",
    "description": "The Casablanca Mirror Frame captures the elegance of ornamental design through intricate mother-of-pearl inlay set against a delicately curved form. Each floral motif is individually hand-cut and embedded into the surface, creating a flowing pattern of vines and blossoms that speak to centuries-old craftsmanship. The a",
    "active": true,
    "media": [
      {
        "id": "mc-casablanca-mirror-frame-mop-m1",
        "path": "casablanca-mirror-frame-mop/01_45340798484701.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-casablanca-mirror-frame-mop-m2",
        "path": "casablanca-mirror-frame-mop/02_45340784558301.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-diamond-bed-side-bone-inlay",
    "code": "KL 1910",
    "title": "Diamond Bed Side Bone Inlay",
    "category": "side_table_consoles",
    "subcategory": "Bed Side",
    "materials": [
      "Engineered Wood",
      "Bone Inlay",
      "Resin"
    ],
    "colours": [
      "Black",
      "White",
      "Red",
      "Brass"
    ],
    "priceMin": 39000,
    "priceMax": 39000,
    "currency": "INR",
    "dims": "50L x 35W x 50H",
    "description": "A striking interplay of black, white, and brass, the Diamond Bedside Table makes a graphic statement in any space. Its handcrafted bone inlay façade features precision-cut geometric forms, creating a layered diamond pattern that commands attention while maintaining symmetry and elegance. Two seamless drawers offer prac",
    "active": true,
    "media": [
      {
        "id": "mc-diamond-bed-side-bone-inlay-m1",
        "path": "diamond-bed-side-bone-inlay/01_45189580357853.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-diamond-bed-side-bone-inlay-m2",
        "path": "diamond-bed-side-bone-inlay/02_45165255065821.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-elisha-side-table",
    "code": "KL 2029",
    "title": "Elisha Side Table",
    "category": "side_table_consoles",
    "subcategory": "Side Table",
    "materials": [
      "Engineered Wood",
      "Bone Inlay",
      "Resin",
      "Brass Painted Iron Stand"
    ],
    "colours": [
      "Default Title",
      "Brass"
    ],
    "priceMin": 38000,
    "priceMax": 38000,
    "currency": "INR",
    "dims": "45L x 45W x 50H",
    "description": "A symphony of elegance and artistry, the Elisha Side Table transforms any space into a haven of sophistication. Its circular tabletop, graced with a stunning floral pattern, celebrates masterful craftsmanship. Delicately crafted from bone inlay, the intricate design evokes the beauty of a blossoming garden, captivating",
    "active": true,
    "media": [
      {
        "id": "mc-elisha-side-table-m1",
        "path": "elisha-side-table/01_45189307465949.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-elisha-side-table-m2",
        "path": "elisha-side-table/02_45170477105373.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-elisha-side-table-m3",
        "path": "elisha-side-table/03_45170477138141.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-elisha-side-table-m4",
        "path": "elisha-side-table/04_45170477170909.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-elisha-side-table-m5",
        "path": "elisha-side-table/05_45170477203677.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-fusion-bed-side",
    "code": "KL 1022",
    "title": "Fusion Bed Side",
    "category": "side_table_consoles",
    "subcategory": "Bed Side",
    "materials": [
      "Engineered Wood Structure",
      "Bone Inlay",
      "Resin"
    ],
    "colours": [
      "Grey",
      "Black",
      "White"
    ],
    "priceMin": 48000,
    "priceMax": 48000,
    "currency": "INR",
    "dims": "45L x 35W x 60H",
    "description": "A bold celebration of pattern and contrast, the Fusion Bedside Table layers a symphony of textures, inlays, and finishes into a striking patchwork composition. From precise geometric motifs and checkerboard bone inlay to engraved metal and clean metal pulls, each panel is a testament to artisanal mastery and visual rhy",
    "active": true,
    "media": [
      {
        "id": "mc-fusion-bed-side-m1",
        "path": "fusion-bed-side/01_45189562892509.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-fusion-bed-side-m2",
        "path": "fusion-bed-side/02_45164740346077.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-fusion-bed-side-m3",
        "path": "fusion-bed-side/03_45164740378845.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-geo-coffee-table",
    "code": "KL 1793",
    "title": "Geo Coffee Table",
    "category": "side_table_consoles",
    "subcategory": "Coffee Table",
    "materials": [
      "Engineered Wood Structure",
      "Marble Inlay"
    ],
    "colours": [
      "Default Title",
      "Black",
      "White",
      "Red"
    ],
    "priceMin": 160000,
    "priceMax": 160000,
    "currency": "INR",
    "dims": "120L x 70W x 40H",
    "description": "Strikingly crafted with engineered wood and an opulent marble inlay, the Geo Coffee Table showcases a bold interplay of angular patterns in black, white, and beige tones. Designed to command attention, this piece is as practical as it is artistic - perfect for hosting coffee conversations, exhibiting decorative accents",
    "active": true,
    "media": [
      {
        "id": "mc-geo-coffee-table-m1",
        "path": "geo-coffee-table/01_45189537956061.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-geo-coffee-table-m2",
        "path": "geo-coffee-table/02_45170362941661.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m3",
        "path": "geo-coffee-table/03_45170362974429.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m4",
        "path": "geo-coffee-table/04_45170363007197.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m5",
        "path": "geo-coffee-table/05_45170363039965.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m6",
        "path": "geo-coffee-table/06_45170363072733.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m7",
        "path": "geo-coffee-table/07_45170363105501.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m8",
        "path": "geo-coffee-table/08_45170363138269.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-geo-coffee-table-m9",
        "path": "geo-coffee-table/09_45170363171037.webp",
        "role": "detail",
        "sort": 9,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-graphic-credenza",
    "code": "KL 1954",
    "title": "Graphic Credenza",
    "category": "chest_cabinet",
    "subcategory": "Sideboard",
    "materials": [
      "Engineered Wood Structure",
      "Bone Inlay",
      "Resin",
      "Powder Coated Ms Base"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 110000,
    "priceMax": 110000,
    "currency": "INR",
    "dims": "160L x 40W x 80H",
    "description": "Bring a touch of modern sophistication to your space with this urbane and elegant Graphic Credenza. Featuring a striking geometric abstract design in contrasting tones, this piece effortlessly blends contemporary artistry with functionality. Its sleek lines and bold patterns make it a statement addition to any living r",
    "active": true,
    "media": [
      {
        "id": "mc-graphic-credenza-m1",
        "path": "graphic-credenza/01_45189419630813.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-graphic-credenza-m2",
        "path": "graphic-credenza/02_45167428010205.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m3",
        "path": "graphic-credenza/03_45167427977437.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m4",
        "path": "graphic-credenza/04_45167427944669.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m5",
        "path": "graphic-credenza/05_45167428042973.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m6",
        "path": "graphic-credenza/06_45167428075741.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m7",
        "path": "graphic-credenza/07_45167428108509.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m8",
        "path": "graphic-credenza/08_45167428141277.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-graphic-credenza-m9",
        "path": "graphic-credenza/09_45167428174045.webp",
        "role": "detail",
        "sort": 9,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-honey-bee-side-table-set-of-2",
    "code": "KL 1876",
    "title": "Honey Bee Cocktail Table Set Of 2",
    "category": "side_table_consoles",
    "subcategory": "Cocktail Table",
    "materials": [
      "Top-Bottom Engineered Wood",
      "Bone Inlay",
      "With Brass Painted Iron Rod"
    ],
    "colours": [
      "Default Title",
      "Gold",
      "Brass"
    ],
    "priceMin": 54000,
    "priceMax": 54000,
    "currency": "INR",
    "dims": "25.5L x 25.5W x 57.5H",
    "description": "These exquisite honeybee-themed side tables, crafted with a harmonious blend of marble-like resin and brass-cladded iron, epitomize artistic finesse and modern luxury. The intricate bee motifs exude a whimsical charm, while the lustrous golden base adds a touch of opulence, making them perfect accent pieces for any sop",
    "active": true,
    "media": [
      {
        "id": "mc-honey-bee-side-table-set-of-2-m1",
        "path": "honey-bee-side-table-set-of-2/01_45189307531485.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-honey-bee-side-table-set-of-2-m2",
        "path": "honey-bee-side-table-set-of-2/02_45170496962781.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-honey-bee-side-table-set-of-2-m3",
        "path": "honey-bee-side-table-set-of-2/03_45170496995549.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-honey-bee-side-table-set-of-2-m4",
        "path": "honey-bee-side-table-set-of-2/04_45170497028317.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-honey-bee-side-table-set-of-2-m5",
        "path": "honey-bee-side-table-set-of-2/05_45170497061085.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-honey-bee-side-table-set-of-2-m6",
        "path": "honey-bee-side-table-set-of-2/06_45170497093853.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-jasmine-hexa-stool-eye-design-grey",
    "code": "KL 1434",
    "title": "Jasmine Hexa Stool Eye Design Grey",
    "category": "side_table_consoles",
    "subcategory": "Side Table",
    "materials": [
      "Engineered Wood Structure",
      "Bone Inlay",
      "Resin"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Grey"
    ],
    "priceMin": 45000,
    "priceMax": 45000,
    "currency": "INR",
    "dims": "55L x 55W x 60H",
    "description": "The Jasmine Hexa Side Table is a striking fusion of geometric elegance and artisanal craftsmanship, featuring an intricate bone inlay design that brings a touch of Moroccan-inspired flair. Its hexagonal shape, supported by four sturdy legs, is adorned with a mesmerizing pattern of diamond motifs and central floral deta",
    "active": true,
    "media": [
      {
        "id": "mc-jasmine-hexa-stool-eye-design-grey-m1",
        "path": "jasmine-hexa-stool-eye-design-grey/01_45189289050333.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-jasmine-hexa-stool-eye-design-grey-m2",
        "path": "jasmine-hexa-stool-eye-design-grey/02_45170428248285.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-june-nesting-table-set-of-2",
    "code": "KL 2041",
    "title": "June Nesting Table Set Of 2",
    "category": "side_table_consoles",
    "subcategory": "Side Table",
    "materials": [
      "Marble Top With Brass Painted Iron Stand"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Brass"
    ],
    "priceMin": 27000,
    "priceMax": 27000,
    "currency": "INR",
    "dims": "38L x 38W x 62H",
    "description": "The June Nesting Side Table epitomizes contemporary elegance, seamlessly blending artistry with functionality. Its polished marble top radiates timeless sophistication, complemented by a quartet of slender, brass-painted iron legs that exude understated charm. A masterful interplay of form and purpose, this versatile n",
    "active": true,
    "media": [
      {
        "id": "mc-june-nesting-table-set-of-2-m1",
        "path": "june-nesting-table-set-of-2/01_45189307498717.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m2",
        "path": "june-nesting-table-set-of-2/02_45170470551773.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m3",
        "path": "june-nesting-table-set-of-2/03_45170470584541.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m4",
        "path": "june-nesting-table-set-of-2/04_45170470617309.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m5",
        "path": "june-nesting-table-set-of-2/05_45170470650077.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m6",
        "path": "june-nesting-table-set-of-2/06_45170470682845.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m7",
        "path": "june-nesting-table-set-of-2/07_45170470715613.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-june-nesting-table-set-of-2-m8",
        "path": "june-nesting-table-set-of-2/08_45170470748381.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-maharaja-mirror-frame-mop",
    "code": "KL 1490",
    "title": "Maharaja Mirror Frame Mop",
    "category": "mirrors",
    "subcategory": "Mirror",
    "materials": [
      "Engineered Wood",
      "Mother of Pearl Inlay"
    ],
    "colours": [
      "Default Title"
    ],
    "priceMin": 140000,
    "priceMax": 140000,
    "currency": "INR",
    "dims": "107L x 70H",
    "description": "An ode to heritage craftsmanship, the Maharaja Mirror is defined by its ornate silhouette and luminous mother of pearl inlay. Intricate floral and geometric motifs unfold across a dark backdrop, creating a striking contrast that feels both timeless and dramatic.Designed to command attention, it works beautifully above ",
    "active": true,
    "media": [
      {
        "id": "mc-maharaja-mirror-frame-mop-m1",
        "path": "maharaja-mirror-frame-mop/01_45189636292829.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-maharaja-mirror-frame-mop-m2",
        "path": "maharaja-mirror-frame-mop/02_45166019641565.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-maharaja-mirror-frame-mop-m3",
        "path": "maharaja-mirror-frame-mop/03_45166020067549.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-maharaja-mirror-frame-mop-m4",
        "path": "maharaja-mirror-frame-mop/04_45166019608797.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-maharaja-mirror-frame-mop-m5",
        "path": "maharaja-mirror-frame-mop/05_45166018658525.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-marrakesh-cabinet",
    "code": "KL 1682",
    "title": "Marrakesh Cabinet",
    "category": "chest_cabinet",
    "subcategory": "Cabinet",
    "materials": [
      "Engineered Wood Structure",
      "Brass Sheet Cladding",
      "Powder Coated Ms Stand"
    ],
    "colours": [
      "Antique Gold",
      "Black",
      "Brass"
    ],
    "priceMin": 120000,
    "priceMax": 120000,
    "currency": "INR",
    "dims": "100L x 40W x 140H",
    "description": "The Marrakesh Cabinet is a statement piece designed to captivate. Clad in hand-embossed brass, its surface is a mosaic of geometric patterns and textures, reminiscent of Moroccan artistry. The tall, slender silhouette is elevated on a minimal iron base, giving it a light yet grounded presence. Perfect for adding charac",
    "active": true,
    "media": [
      {
        "id": "mc-marrakesh-cabinet-m1",
        "path": "marrakesh-cabinet/01_45191223312605.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-marrakesh-cabinet-m2",
        "path": "marrakesh-cabinet/02_45191218331869.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-marrakesh-cabinet-m3",
        "path": "marrakesh-cabinet/03_45191218364637.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-marrakesh-cabinet-m4",
        "path": "marrakesh-cabinet/04_45191218397405.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-marrakesh-cabinet-m5",
        "path": "marrakesh-cabinet/05_45191218430173.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-marrakesh-cabinet-m6",
        "path": "marrakesh-cabinet/06_45191218462941.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-marrakesh-cabinet-m7",
        "path": "marrakesh-cabinet/07_45191218495709.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-mirror-frame",
    "code": "KL 471",
    "title": "Mirror Frame",
    "category": "mirrors",
    "subcategory": "Mirror",
    "materials": [
      "Engineered Wood",
      "White Metal Sheet Cladding"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Natural"
    ],
    "priceMin": 52000,
    "priceMax": 52000,
    "currency": "INR",
    "dims": "80L x 80H",
    "description": "The Round Mirror Frame is a bold composition of rhythm and reflection. Wrapped in concentric ridges of hand-clad metal, its surface creates a dynamic visual texture that catches light across every curve. The circular form - clean, sculptural, and dimensional adds depth to any interior without overwhelming the space. Th",
    "active": true,
    "media": [
      {
        "id": "mc-mirror-frame-m1",
        "path": "mirror-frame/01_45340753428701.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-mirror-frame-m2",
        "path": "mirror-frame/02_45262537228509.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-mudra-bed-side",
    "code": "KL 1503",
    "title": "Mudra Bed Side",
    "category": "side_table_consoles",
    "subcategory": "Bed Side",
    "materials": [
      "Engineered Wood Structure",
      "White Metal Cladding",
      "Powder Coated Ms Legs"
    ],
    "colours": [
      "Black",
      "Gold",
      "Red",
      "Brass"
    ],
    "priceMin": 29000,
    "priceMax": 29000,
    "currency": "INR",
    "dims": "45L x 35W x 55H",
    "description": "A study in tactile detail and streamlined structure, the Mudra Bedside Table blends modern geometry with artisanal craft. Its three-tiered composition features a top drawer clad in ribbed brass, a middle in a matte black finish and a bottom drawer embossed in a pebble-inspired relief - each surface playing with texture",
    "active": true,
    "media": [
      {
        "id": "mc-mudra-bed-side-m1",
        "path": "mudra-bed-side/01_45189576884445.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-mudra-bed-side-m2",
        "path": "mudra-bed-side/02_45165269254365.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-noir-round-coffee-table",
    "code": "KL 1807",
    "title": "Noir Round Coffee Table",
    "category": "side_table_consoles",
    "subcategory": "Coffee Table",
    "materials": [
      "Engineered Wood Structure With Brass Sheet Cladding",
      "Marble Top With Powder Coated Ms Legs"
    ],
    "colours": [
      "Default Title",
      "Black",
      "Red",
      "Gold"
    ],
    "priceMin": 72000,
    "priceMax": 72000,
    "currency": "INR",
    "dims": "90L x 90W x 40H",
    "description": "A refined statement piece, the Noir Round Coffee Table seamlessly blends engineered wood, intricate metalwork, a luxurious marble top, and sturdy iron legs, exuding both durability and elegance. Its round form softens sharp interiors while the textured gold finish and bold black accents create a striking contrast, maki",
    "active": true,
    "media": [
      {
        "id": "mc-noir-round-coffee-table-m1",
        "path": "noir-round-coffee-table/01_45189496045789.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-noir-round-coffee-table-m2",
        "path": "noir-round-coffee-table/02_45170372313309.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-noir-round-coffee-table-m3",
        "path": "noir-round-coffee-table/03_45170372346077.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-noir-round-coffee-table-m4",
        "path": "noir-round-coffee-table/04_45170372378845.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-scallop-mirror-frame-w-m",
    "code": "KL 544",
    "title": "Scallop Mirror Frame W/M",
    "category": "mirrors",
    "subcategory": "Mirror",
    "materials": [
      "Engineered Wood",
      "White Metal Sheet Cladding"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Silver",
      "Natural"
    ],
    "priceMin": 52000,
    "priceMax": 52000,
    "currency": "INR",
    "dims": "80L x 80H",
    "description": "The Scallop Mirror Frame brings sculptural drama to the wall with its deep, fluted contours and gleaming hand-clad metal surface. Each wave-like curve is shaped to reflect and refract light, creating a sense of movement around the central mirror. The circular form, paired with the bold, dimensional frame, makes this pi",
    "active": true,
    "media": [
      {
        "id": "mc-scallop-mirror-frame-w-m-m1",
        "path": "scallop-mirror-frame-w-m/01_45340733079773.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-scallop-mirror-frame-w-m-m2",
        "path": "scallop-mirror-frame-w-m/02_45262533165277.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-soho-side-table",
    "code": "KL 2098",
    "title": "Soho Side Table",
    "category": "side_table_consoles",
    "subcategory": "Side Table",
    "materials": [
      "Engineered Wood",
      "Bone Inlay",
      "Resin",
      "Metal Work With Powder Coated Ms Legs"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 34000,
    "priceMax": 34000,
    "currency": "INR",
    "dims": "50L x 50W x 60H",
    "description": "The Soho Side Table is a masterpiece of contemporary design, blending sophisticated aesthetics with unmatched functionality. Crafted from premium engineered wood, its surface is adorned with intricate bone inlay and sleek metal cladding, creating a striking interplay of texture and pattern. Supported by sturdy iron leg",
    "active": true,
    "media": [
      {
        "id": "mc-soho-side-table-m1",
        "path": "soho-side-table/01_45189289017565.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-soho-side-table-m2",
        "path": "soho-side-table/02_45170435293405.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-soho-side-table-m3",
        "path": "soho-side-table/03_45170435326173.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-soho-side-table-m4",
        "path": "soho-side-table/04_45170435358941.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-step-credenza",
    "code": "KL 1883",
    "title": "Step Credenza",
    "category": "chest_cabinet",
    "subcategory": "Sideboard",
    "materials": [
      "Engineered Wood Structure",
      "Brass Sheet Cladding",
      "Powder Coated Ms Base"
    ],
    "colours": [
      "Default Title",
      "Black",
      "Red",
      "Gold"
    ],
    "priceMin": 120000,
    "priceMax": 120000,
    "currency": "INR",
    "dims": "160L x 40W x 80H",
    "description": "The Step Credenza is a stunning fusion of contemporary design and timeless glamour. Featuring a luminous gold finish with intricately layered step patterns, it exudes a sense of bold sophistication. The sleek black metal base adds a touch of modern minimalism, creating a perfect harmony between elegance and functionali",
    "active": true,
    "media": [
      {
        "id": "mc-step-credenza-m1",
        "path": "step-credenza/01_45189479301341.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-step-credenza-m2",
        "path": "step-credenza/02_45167452717277.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-step-credenza-m3",
        "path": "step-credenza/03_45167452750045.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-step-credenza-m4",
        "path": "step-credenza/04_45167452782813.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-step-credenza-m5",
        "path": "step-credenza/05_45167452815581.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-step-credenza-m6",
        "path": "step-credenza/06_45167452848349.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-step-credenza-m7",
        "path": "step-credenza/07_45167452881117.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-sunburst-2-door-credenza-brass",
    "code": "KL 2040",
    "title": "Sunburst 2 Door Credenza Brass",
    "category": "chest_cabinet",
    "subcategory": "Sideboard",
    "materials": [
      "Engineered Wood Structure",
      "Brass Sheet Cladding"
    ],
    "colours": [
      "Default Title",
      "Gold",
      "Red",
      "Brass"
    ],
    "priceMin": 150000,
    "priceMax": 150000,
    "currency": "INR",
    "dims": "160L x 40W x 80H",
    "description": "Make a bold statement with this exquisitely crafted Sunburst two-Door Sideboard. Featuring a radiant golden sunburst design, this hand-crafted masterpiece brings sophistication and glamour to any space. Beyond its stunning aesthetic, it offers ample storage, making it a perfect blend of style and functionality. Whether",
    "active": true,
    "media": [
      {
        "id": "mc-sunburst-2-door-credenza-brass-m1",
        "path": "sunburst-2-door-credenza-brass/01_45189409079517.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m2",
        "path": "sunburst-2-door-credenza-brass/02_45167406481629.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m3",
        "path": "sunburst-2-door-credenza-brass/03_45167406579933.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m4",
        "path": "sunburst-2-door-credenza-brass/04_45167406612701.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m5",
        "path": "sunburst-2-door-credenza-brass/05_45167406547165.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m6",
        "path": "sunburst-2-door-credenza-brass/06_45167406416093.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m7",
        "path": "sunburst-2-door-credenza-brass/07_45167406448861.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunburst-2-door-credenza-brass-m8",
        "path": "sunburst-2-door-credenza-brass/08_45167406514397.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-sunray-coffee-table",
    "code": "KL 1537",
    "title": "Sunray Coffee Table",
    "category": "side_table_consoles",
    "subcategory": "Coffee Table",
    "materials": [
      "Engineered Wood Structure",
      "Bone Inlay Work"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 80000,
    "priceMax": 80000,
    "currency": "INR",
    "dims": "100L x 100W x 45H",
    "description": "The Sunray Coffee Table captivates with its striking bone inlay design, radiating from the center like sunbeams to create a bold yet elegant visual statement. Expertly crafted on an engineered wood base, this table seamlessly blends artisanal heritage with contemporary sophistication. Its monochrome pattern makes it a ",
    "active": true,
    "media": [
      {
        "id": "mc-sunray-coffee-table-m1",
        "path": "sunray-coffee-table/01_45189551784157.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-sunray-coffee-table-m2",
        "path": "sunray-coffee-table/02_45170378834141.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-sunray-coffee-table-m3",
        "path": "sunray-coffee-table/03_45170378801373.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-sunray-credenza-bone",
    "code": "KL 1542",
    "title": "Sunray Credenza Bone",
    "category": "chest_cabinet",
    "subcategory": "Sideboard",
    "materials": [
      "Engineered Wood Structure",
      "Bone Inlay",
      "Resin",
      "Brass Plated Stand"
    ],
    "colours": [
      "Default Title",
      "Red",
      "Brass"
    ],
    "priceMin": 120000,
    "priceMax": 120000,
    "currency": "INR",
    "dims": "160L x 40W x 80H",
    "description": "The Sunray Credenza Bone Sideboard commands attention with its mesmerizing pattern of hand-cut bone inlay, radiating outward like ripples of light. Each segment is meticulously arranged to form a hypnotic optical rhythm, centered by a gleaming brass accent that anchors the design in modern luxury. Set on a minimal bras",
    "active": true,
    "media": [
      {
        "id": "mc-sunray-credenza-bone-m1",
        "path": "sunray-credenza-bone/01_45189424021725.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-sunray-credenza-bone-m2",
        "path": "sunray-credenza-bone/02_45167397798109.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-sunray-credenza-bone-m3",
        "path": "sunray-credenza-bone/03_45167397830877.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-sunray-credenza-bone-m4",
        "path": "sunray-credenza-bone/04_45167397863645.webp",
        "role": "detail",
        "sort": 4,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunray-credenza-bone-m5",
        "path": "sunray-credenza-bone/05_45167397896413.webp",
        "role": "detail",
        "sort": 5,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunray-credenza-bone-m6",
        "path": "sunray-credenza-bone/06_45167397929181.webp",
        "role": "detail",
        "sort": 6,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunray-credenza-bone-m7",
        "path": "sunray-credenza-bone/07_45167397961949.webp",
        "role": "detail",
        "sort": 7,
        "allowedSend": false,
        "featured": false
      },
      {
        "id": "mc-sunray-credenza-bone-m8",
        "path": "sunray-credenza-bone/08_45167397994717.webp",
        "role": "detail",
        "sort": 8,
        "allowedSend": false,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-tapered-mirror-frame",
    "code": "KL 247",
    "title": "Tapered Mirror Frame",
    "category": "mirrors",
    "subcategory": "Mirror",
    "materials": [
      "Engineered Wood",
      "White Metal Sheet Cladding"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 45500,
    "priceMax": 45500,
    "currency": "INR",
    "dims": "80L x 80H",
    "description": "The Tapered Mirror Frame offers a balanced blend of modern proportion and handcrafted detail. Its bold circular form is wrapped in brushed metal cladding, softly textured to catch light while maintaining a refined, matte presence. Subtle contouring along the frame’s edge introduces dimension and depth without overpower",
    "active": true,
    "media": [
      {
        "id": "mc-tapered-mirror-frame-m1",
        "path": "tapered-mirror-frame/01_45340878438621.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-tapered-mirror-frame-m2",
        "path": "tapered-mirror-frame/02_45166879703261.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-the-london-credenza",
    "code": "KL 1533",
    "title": "The London Credenza",
    "category": "chest_cabinet",
    "subcategory": "Sideboard",
    "materials": [
      "Engineered Wood Structure",
      "Metal Cladding"
    ],
    "colours": [
      "Default Title",
      "Red"
    ],
    "priceMin": 220000,
    "priceMax": 220000,
    "currency": "INR",
    "dims": "182L x 46W x 86H",
    "description": "Step into a fairytale with The London Console, a statement piece that exudes vibrance and charm. Its striking metallic finish and intricately designed radial patterns create unparalleled depth and dimension, transforming any space into a luxurious haven. Bespoke craftsmanship meets contemporary elegance, making this co",
    "active": true,
    "media": [
      {
        "id": "mc-the-london-credenza-m1",
        "path": "the-london-credenza/01_45189439127773.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-the-london-credenza-m2",
        "path": "the-london-credenza/02_45167476736221.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      },
      {
        "id": "mc-the-london-credenza-m3",
        "path": "the-london-credenza/03_45167496757469.webp",
        "role": "detail",
        "sort": 3,
        "allowedSend": true,
        "featured": false
      }
    ]
  },
  {
    "id": "mc-white-luxe-mirror",
    "code": "KL 547",
    "title": "White Luxe Mirror",
    "category": "mirrors",
    "subcategory": "Mirror",
    "materials": [
      "Engineered Wood",
      "White Metal Sheet Cladding"
    ],
    "colours": [
      "Default Title",
      "White"
    ],
    "priceMin": 42000,
    "priceMax": 42000,
    "currency": "INR",
    "dims": "120L x 80H",
    "description": "The Rectangular Mirror Frame embraces refined minimalism with a touch of sculptural geometry. Its wide, bevelled edges are hand-clad in brushed white metal, offering a clean matte sheen that complements both modern and transitional interiors. The precise corner joins and faceted form create a subtle play of depth and l",
    "active": true,
    "media": [
      {
        "id": "mc-white-luxe-mirror-m1",
        "path": "white-luxe-mirror/01_45340710797533.webp",
        "role": "hero",
        "sort": 1,
        "allowedSend": true,
        "featured": true
      },
      {
        "id": "mc-white-luxe-mirror-m2",
        "path": "white-luxe-mirror/02_45166461124829.webp",
        "role": "detail",
        "sort": 2,
        "allowedSend": true,
        "featured": false
      }
    ]
  }
];
